<div class="bank-accounts-list-container">
    <h1>Bank Accounts</h1>
    <div *ngIf="loading == true">
        <h2>Loading bank account data...</h2>
    </div>
    <div *ngIf="loading == false">
        <div *ngIf="noBankAccountsFound == true">
            <h2>No bank accounts found...</h2>
            <p><a [routerLink]="'/bank/accounts/providers/credentials'">Click here to setup your bank accounts.</a></p>
        </div>
        <div *ngIf="noBankAccountsFound == false" fxLayout="row wrap" fxLayoutAlign="center center" >
            <div *ngFor="let account of bankAccounts">
                <mat-card class="account-card">
                    <mat-card-header>
                        <mat-card-title>{{account.Name}}</mat-card-title>
                        <mat-card-subtitle>{{account.CurrentBalance | currency}}</mat-card-subtitle>
                        <img *ngIf="account.BankLogoUrl" mat-card-avatar
                        src="{{account.BankLogoUrl}}" />
                    </mat-card-header>
                    <mat-card-content fxLayout="row" fxLayoutAlign="space-between center">
                        <div>
                            <div>{{account.FormattedAccount}}</div>
                            <div><small>Account Number</small></div>
                        </div>
                        <div class="account-card-data-item-rh">
                            <div>{{account.LastSyncedAt | amTimeAgo}}</div>
                            <div><small>Last Synced</small></div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions>
                        <button type="button" mat-button color="primary" [routerLink]="['../accounts', account.Id]">
                            <mat-icon>folder_open</mat-icon>Open
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
    </div>
    <app-fab-menu [buttons]="fabButtons" icon="build"></app-fab-menu>
</div>
